const mcrvapedistro = {
    id: 'mcrvapedistro',
    publicSiteName: 'Mcr Vape Distro',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#75a500',
            secondary: '#000000',
            color1: '#fc0808',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'minimal',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/mcrvapedistro/favicon.ico',
        logo: '/mcrvapedistro/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default mcrvapedistro